import type { EntityConfig } from "@/v2/framework/registry/types";
import { createOutcomesView } from "./grid/view";

export default {
  id: "outcomes",
  name: "outcomes",
  title: "metadata.outcomes",
  position: 6,
  create: (ctx) => createOutcomesView(ctx),
} satisfies EntityConfig;
